import apiClient from '../apiClient';

class InvoiceService {
  async getAll(status) {
    const query = status ? `?status=${encodeURIComponent(status)}` : '';
    const response = await apiClient.get(`/invoices${query}`);
    return response || [];
  }

  async getById(id) {
    return await apiClient.get(`/invoices/${id}`);
  }

  async create(data) {
    return await apiClient.post('/invoices', data);
  }

  async update(id, data) {
    return await apiClient.patch(`/invoices/${id}`, data);
  }

  async updateStatus(id, status, extra = {}) {
    return await apiClient.patch(`/invoices/${id}/status`, { status, ...extra });
  }

  async delete(id) {
    return await apiClient.delete(`/invoices/${id}`);
  }

  async getNextNumber() {
    const response = await apiClient.get('/invoices/next-number');
    return response?.nextNumber || 'INV-001';
  }

  async getInsights() {
    return await apiClient.get('/invoices/insights');
  }
}

export default InvoiceService;
